import { isSafariWithoutFullWasmSupport } from "./isSafariWithoutFullWasmSupport.js";
export const checkSupport = () => {
    // Check if WebAssembly is supported reliably (i.e., not in Safari <= 11.1)
    const wasm = (() => {
        // Check if WebAssembly is supported
        if (typeof WebAssembly !== "object" ||
            typeof WebAssembly.instantiate !== "function") {
            return false;
        }
        // Check if the browser <= Safari 11.1 which has known issues with WebAssembly
        if (isSafariWithoutFullWasmSupport()) {
            return false;
        }
        return true;
    })();
    // Check if canvas is supported
    const canvas = (() => {
        try {
            const canvas = document.createElement("canvas");
            return !!(canvas && canvas.getContext);
        }
        catch (_a) {
            return false;
        }
    })();
    // Check if WebGL2 is supported
    const webgl2 = (() => {
        try {
            const canvas = document.createElement("canvas");
            return !!(canvas.getContext && canvas.getContext("webgl2"));
        }
        catch (_a) {
            return false;
        }
    })();
    return {
        all: wasm && canvas && webgl2,
        wasm,
        canvas,
        webgl2,
    };
};
